import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import cancelarReservasPedido from '../../actions/reserva/cancelarReservasPedido';
import {formatarReal} from '../../util/numberUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalConfirmacaoCancelamentoPedido extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoCancelamentoPedido')
      .modal('hide');
    $('#modalConfirmacaoCancelamentoPedido')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.props.cancelarReservasPedido(values.observacao, this.props.empresaSelecionada.id, this.props.pedido.id)
      .then(() => {
          showSuccessMsg('Pedido cancelado com sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirTaxaRemarcacao () {
    let taxa = 0.00;
    let valorTotal = 0.00;
    let estorno = 0.00;
    if (this.props.reservas) {
      this.props.reservas
        .forEach(reserva => {
          taxa += Number(reserva.custoCancelamento);
          valorTotal += formatarReal(reserva.taxaEmbarque) ? (Number(reserva.taxaEmbarque) + Number(reserva.valor)) : reserva.valor;
        })
      estorno = valorTotal - taxa;
    }

    return <div className="form-row ml-2">
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Total:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {valorTotal
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Taxa:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {taxa
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Estorno:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {estorno
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
    </div>

  }

  exibirReservas () {
    return <div className='mt-4 ml-2'>
      Reservas:
      <ul>
        {this.props.reservas.map(reserva => <React.Fragment key={reserva.id}>
            <li>{reserva.descCidadeOrigem} -&gt; {reserva.descCidadeDestino}: {reserva.passageiroDto.nome}</li>
          </React.Fragment>)}
      </ul>
    </div>
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoCancelamentoPedido" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoCancelamentoPedido" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="modal-body">
                {this.props.reservas
                  ?
                  <React.Fragment>
                    {this.exibirTaxaRemarcacao()}
                    {this.exibirReservas()}
                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea} validate={[required]} className="form-control" label="Motivo do cancelamento:"/>
                  </React.Fragment>
                  : ''}
              </div>
              <div className="modal-footer ">
                <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Sim
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    reservas: state.pedido ? state.pedido.reservas : [],
    pedido: state.pedido,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  cancelarReservasPedido
})(reduxForm({
  form: 'formularioCancelamentoPedido',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoCancelamentoPedido));
